import React, { useEffect, useState } from "react";
import RedoSubjectReadOnly from "./re_registration_sub_read_only/RedoSubjectReadOnly";
import { useFormik } from "formik";
import * as Yup from "yup";
import Swal from "sweetalert2";
import { submitReRegistrationService } from "../../../services/ReRegistrationService";
import DigitalSignatureComponent from "../../common/DigitalSignatureComponent";
import StudentTypeButton from "../components/StudentTypeButton";
import { getFoundationOptions } from "../../../utils/CommonGroupingItem";
import { useParams } from "react-router-dom";
import { TextLink } from "../../common/GlobalElements/Typography";
import { StandardButton } from "../../common/GlobalElements/StandardButton";

function StandardReRegReadOnly(props) {
  const {
    registration,
    reRegSubject,
    subjectReDoReadOnly,
    foundation,
    subjectProgressReadOnly,
    readOnlyData,
    student_type
  } = props;

  const { regid } = useParams()
  
  const [parentSubjectRedoLength, setParentSubjectRedoLength] = useState([
    { subject: "" },
  ]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);
  const [foundationOptions, setFoundationOptions] = useState([]);
  
  const handleCheck = (e) => {
    setChecked(e.target.checked);
  };
  
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      subjectRedo_:  subjectReDoReadOnly,
      subjectProgress_ : subjectProgressReadOnly,
      rereg_academy: props?.registration?.academy,
      rereg_id: props?.registration?.id,
      term_condn: checked,
      student_type: student_type,      
    },
    validationSchema: Yup.object({
      subjectRedo_: Yup.array()
      .of(
        Yup.object().shape({
          subject: Yup.string().required("Required"), // these constraints take precedence
        })
      )
      .required("Must have friends"),
      term_condn: Yup.bool().oneOf(
        [true],
        "Accept Terms & Conditions is required"
      ),
    }),
    onSubmit: (values) => {
      submitReRegistrationService(values).then((res) => {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "You'r Registration have been submited succefully",
          timer: 3000,
          onOpen: function () {
            Swal.showLoading();
          },
        }).then(function (result) {
          setLoading(true);
        });
      });
    },
  });

  useEffect(() => {
    if(regid){
      getFoundationOptions(regid, setFoundationOptions);
    }
  }, [regid]);
  console.log("foundation", foundation);
  console.log("foundationOptions", foundationOptions);
    return (
    <>
    <form onSubmit={formik.handleSubmit} className="disabled">
    <div className="card-body">
    <div className="theme-form application-form">
    <div className="row">

      <StudentTypeButton 
      disabled={true}
      formik={formik}
      />      
        
        {(Number(formik.values.student_type)  === 0 || Number(formik.values.student_type)  === 2) && (
        <>
        <div className="form-group col-sm-12 inputfield">        
        <h5 className="textdanger heading-5">Re-registering for Failed Modules:</h5>
        <label>
Please select the subjects you wish to re-register for. These are subjects you did not pass or would like to attempt again. If you do not wish to repeat any subjects, simply leave this section blank.<br/><br/>
        </label>
        <RedoSubjectReadOnly
        formik={formik}
        setParentSubjectRedoLength={setParentSubjectRedoLength}
        parentSubjectRedoLength={parentSubjectRedoLength}
        reRegSubject={reRegSubject}
        />
        </div>    
        </>)}
        {Number(formik.values.student_type)  === 1 && foundationOptions?.length > 0 && (
          <>
          <div className="form-group col-sm-12 inputfield">
          <h5 className="textdanger heading-5"> Programme Articulation:</h5>
          <p>If you have successfully completed your current qualification, please indicate the programme you wish to articulate into for your next level of study.</p>
          {subjectProgressReadOnly?.[0]?.subject && 
            <>
            <div className="row" key ={"progress1"}>
            <div key={"progress1"} className="col-sm-6">
            <select
            className="form-control"
            value={subjectProgressReadOnly?.[0]?.subject}
            disabled={true}
            >
            {(() => {
              const id = String(subjectProgressReadOnly?.[0]?.subject);
              const match = foundation && foundationOptions.find(o => id !== "0" && id === String(o.value));
              return match
              ? <option key={match.value} value={match.value}>{match.label}</option>
              : <option value="">---</option>;
            })()}     
            </select>
            </div>
            </div>
            </>
            }
            </div>
            </>)}
          <div className="form-group col-sm-12 inputfield">            
            <DigitalSignatureComponent readOnly={true} readOnlyData={readOnlyData}/>
            </div>
            <div className="col-12 form-group inputfield">
            <div className="custom-control custom-checkbox text-left box-tm">
            <input
            className={
              "custom-control-input " +
              (formik.touched.term_condn && formik.errors.term_condn
                ? " is-invalid"
                : "")
              }
              type="checkbox"
              name="term_condn"
              onChange={(e) => handleCheck(e)}
              onBlur={formik.handleBlur}
              checked="checked"
              id="customCheck1"
              disabled="disabled"
              />
              
              <label
              className="custom-control-label textdanger"
              htmlFor="customCheck1"
              >
              I hereby confirm that I have read, understood and accepted
              all <TextLink href={registration?.linkTandC} target="_blank">Terms and Conditions</TextLink> as set out in the application form that the above subject selections are correct, and understand
              that there may be changes made based on the academic outcome.
              </label>
              {formik.touched.term_condn && formik.errors.term_condn ? (
                <div className="invalid-feedback">
                {formik.errors.term_condn}
                </div>
              ) : null}
              </div>
              </div>
              </div>
              </div>
              <div className="Fmfooter">
              <StandardButton
                variant="primary"
                title="Submitted"
                type="submit"
                disabled="disabled"
              >
              {loading && <i className="fas fa-cog fa-spin"></i>} Submitted
              </StandardButton>
                </div>
                </div>
                </form>
                </>
              );
            }
            export default StandardReRegReadOnly;
            